module.exports = __webpack_public_path__ + "static/media/Roboto-700.50d75e48.woff";